/**
 * Facturation à la consommation, par utilisateur actif.
 *
 * La plupart de ces clés sont atteintes via `const { t: translate }`, que le
 * contrôle de couverture ne détecte pas : il ne reconnaît que `t('...')`
 * littéral. Elles sont donc maintenues à la main et apparaîtront dans la liste
 * « non référencées », ce qui est attendu.
 */
export const billing: Record<string, string> = {
  'Active users this period and what they cost':
    'Utilisateurs actifs sur la période et ce qu’ils coûtent',
  '{plan} plan': 'Formule {plan}',
  'Billed annually, measured monthly, settled each quarter.':
    'Facturé annuellement, mesuré mensuellement, régularisé chaque trimestre.',
  'Billed each month for the users who were active in it.':
    'Facturé chaque mois pour les utilisateurs qui y ont été actifs.',
  'Refreshing…': 'Actualisation…',
  'Unable to load billing details': 'Impossible de charger les détails de facturation',
  'Billing details are not available for this account.':
    'Les détails de facturation ne sont pas disponibles pour ce compte.',

  'Current period': 'Période en cours',
  'Billable users this period': 'Utilisateurs facturables sur la période',
  '{count} days left': '{count} jours restants',
  'Guards who clocked in': 'Agents ayant pointé',
  'Admins and managers who signed in': 'Administrateurs et responsables connectés',
  'Distinct active users': 'Utilisateurs actifs distincts',
  'Plan minimum': 'Minimum de la formule',
  'Projected this month': 'Projection pour ce mois',
  'Projected at this rate, per year': 'Projection à ce rythme, par an',
  'No active price for this plan': 'Aucun tarif actif pour cette formule',
  '{price} per user per month, excluding VAT': '{price} par utilisateur et par mois, hors TVA',
  '{price} per user per year, excluding VAT': '{price} par utilisateur et par an, hors TVA',

  'Fewer than {count} users have been active, so this period bills at the {count}-user minimum.':
    'Moins de {count} utilisateurs ont été actifs : cette période est donc facturée au minimum de {count} utilisateurs.',
  'Above the {count}-user minimum, so you are billed for the {billable} distinct people who used Odinseye this period.':
    'Au-dessus du minimum de {count} utilisateurs : vous êtes facturé pour les {billable} personnes distinctes ayant utilisé Odinseye sur la période.',
  'A guard is counted once they clock into a shift, never for being on the roster. Deactivate a leaver from their Staff profile and they stop counting from the next period.':
    'Un agent est compté dès qu’il pointe sur un service, jamais parce qu’il figure au planning. Désactivez un partant depuis son profil dans Personnel et il cesse d’être compté dès la période suivante.',

  'Irish VAT is added to the amounts shown.': 'La TVA irlandaise s’ajoute aux montants affichés.',
  'Invoiced under the UK reverse charge. VAT is accounted for by you.':
    'Facturé en autoliquidation au Royaume-Uni. La TVA est déclarée par vos soins.',
  'Invoiced under the intra-community reverse charge against your VAT number.':
    'Facturé en autoliquidation intracommunautaire sur la base de votre numéro de TVA.',
  'VAT number on file: {number}': 'Numéro de TVA enregistré : {number}',

  'Annual commitment': 'Engagement annuel',
  'Annual commitment and quarterly true-up': 'Engagement annuel et régularisation trimestrielle',
  'No committed user count is recorded, so the plan minimum is used as the baseline.':
    'Aucun nombre d’utilisateurs engagé n’est enregistré : le minimum de la formule sert de référence.',
  'You committed to {count} users. Each quarter we compare the average of the three measured months against that baseline and invoice only the excess, so one busy month does not land whole.':
    'Vous vous êtes engagé sur {count} utilisateurs. Chaque trimestre, nous comparons la moyenne des trois mois mesurés à cette référence et ne facturons que l’excédent : un mois chargé ne tombe donc pas d’un bloc.',
  'No quarter has been settled yet.': 'Aucun trimestre n’a encore été régularisé.',
  'Quarter': 'Trimestre',
  'Committed': 'Engagé',
  'Average': 'Moyenne',
  'Peak month': 'Mois le plus chargé',
  'Charged for': 'Facturé pour',
  'Amount': 'Montant',

  'Closed periods': 'Périodes clôturées',
  'Usage history': 'Historique de consommation',
  'What was measured in each period that has already closed. These are the figures billing works from.':
    'Ce qui a été mesuré sur chaque période déjà clôturée. Ce sont les chiffres sur lesquels la facturation s’appuie.',
  'Nothing has closed yet. The first period closes at the start of next month.':
    'Rien n’est encore clôturé. La première période se clôture au début du mois prochain.',
  'Distinct users': 'Utilisateurs distincts',
  'Billed for': 'Facturé pour',
  'Sent': 'Envoyé',
  'Sent to billing': 'Transmis à la facturation',
  'Invoiced': 'Facturé',
  'Waived': 'Annulé',
  'Void': 'Sans objet',
  'Not yet': 'Pas encore',
  'minimum': 'minimum',

  'All amounts exclude VAT. To change plan, add a purchase order, or discuss volume pricing, email':
    'Tous les montants sont hors TVA. Pour changer de formule, ajouter un bon de commande ou discuter des tarifs par volume, écrivez à',
};
